const createGalleryPlaceholder = (label, accentA, accentB) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 900" role="img" aria-label="${label}">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#07111f" />
          <stop offset="55%" stop-color="#102746" />
          <stop offset="100%" stop-color="#081019" />
        </linearGradient>
        <linearGradient id="glow" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${accentA}" stop-opacity="0.95" />
          <stop offset="100%" stop-color="${accentB}" stop-opacity="0.92" />
        </linearGradient>
      </defs>
      <rect width="1200" height="900" fill="url(#bg)" rx="48" />
      <circle cx="1030" cy="145" r="180" fill="url(#glow)" opacity="0.28" />
      <circle cx="220" cy="735" r="205" fill="${accentA}" opacity="0.18" />
      <rect x="94" y="88" width="1012" height="724" rx="40" fill="none" stroke="rgba(255,255,255,0.16)" stroke-width="4" />
      <path d="M94 450h1012M600 88v724" stroke="rgba(255,255,255,0.16)" stroke-width="4" fill="none" />
      <circle cx="600" cy="450" r="88" fill="none" stroke="rgba(255,255,255,0.24)" stroke-width="4" />
      <rect x="94" y="262" width="162" height="376" rx="18" fill="none" stroke="rgba(255,255,255,0.14)" stroke-width="4" />
      <rect x="944" y="262" width="162" height="376" rx="18" fill="none" stroke="rgba(255,255,255,0.14)" stroke-width="4" />
      <circle cx="600" cy="450" r="23" fill="url(#glow)" />
      <text x="94" y="170" fill="#ffffff" font-family="Poppins, Arial, sans-serif" font-size="44" font-weight="700" letter-spacing="10">${label}</text>
      <text x="94" y="228" fill="rgba(255,255,255,0.76)" font-family="Poppins, Arial, sans-serif" font-size="24" letter-spacing="4">CLUB AL BURAQ SPORTIF</text>
      <text x="94" y="760" fill="${accentB}" font-family="Oswald, Arial, sans-serif" font-size="92" letter-spacing="8">YOUTH FOOTBALL</text>
      <text x="94" y="816" fill="rgba(255,255,255,0.55)" font-family="Poppins, Arial, sans-serif" font-size="28" letter-spacing="4">AIN ATIQ · MOROCCO</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const galleryItems = [
  {
    id: "gallery-1",
    src: createGalleryPlaceholder("TRAINING 01", "#2980b9", "#f39c12"),
    alt: {
      fr: "Placeholder stylisé pour une séance d'entraînement",
      ar: "صورة مؤقتة أنيقة لحصة تدريبية",
    },
    title: {
      fr: "Séance Technique",
      ar: "حصة تقنية",
    },
  },
  {
    id: "gallery-2",
    src: createGalleryPlaceholder("TRAINING 02", "#1a3a5c", "#e67e22"),
    alt: {
      fr: "Placeholder stylisé pour le travail d'équipe",
      ar: "صورة مؤقتة أنيقة للعمل الجماعي",
    },
    title: {
      fr: "Travail Collectif",
      ar: "العمل الجماعي",
    },
  },
  {
    id: "gallery-3",
    src: createGalleryPlaceholder("MATCH DAY", "#5dade2", "#f39c12"),
    alt: {
      fr: "Placeholder stylisé pour un jour de match",
      ar: "صورة مؤقتة أنيقة ليوم المباراة",
    },
    title: {
      fr: "Jour de Match",
      ar: "يوم المباراة",
    },
  },
  {
    id: "gallery-4",
    src: createGalleryPlaceholder("TEAM SPIRIT", "#2980b9", "#e67e22"),
    alt: {
      fr: "Placeholder stylisé pour l'esprit d'équipe",
      ar: "صورة مؤقتة أنيقة لروح الفريق",
    },
    title: {
      fr: "Esprit d'Équipe",
      ar: "روح الفريق",
    },
  },
  {
    id: "gallery-5",
    src: createGalleryPlaceholder("ACADEMY LIFE", "#1a3a5c", "#f39c12"),
    alt: {
      fr: "Placeholder stylisé pour la vie de l'académie",
      ar: "صورة مؤقتة أنيقة لحياة الأكاديمية",
    },
    title: {
      fr: "Vie de l'Académie",
      ar: "حياة الأكاديمية",
    },
  },
  {
    id: "gallery-6",
    src: createGalleryPlaceholder("FUTURE STARS", "#5dade2", "#e67e22"),
    alt: {
      fr: "Placeholder stylisé pour les futures stars",
      ar: "صورة مؤقتة أنيقة لنجوم المستقبل",
    },
    title: {
      fr: "Futures Étoiles",
      ar: "نجوم المستقبل",
    },
  },
];

export const content = {
  fr: {
    code: "fr",
    brand: "AL BURAQ",
    languageSwitch: "العربية",
    academyBadge: "Académie de football pour jeunes · 5 à 15 ans",
    nav: [
      { id: "about", label: "À propos" },
      { id: "why-us", label: "Pourquoi nous" },
      { id: "gallery", label: "Galerie" },
      { id: "results", label: "Résultats" },
      { id: "testimonials", label: "Témoignages" },
      { id: "videos", label: "Vidéos" },
      { id: "registration", label: "Inscription" },
      { id: "contact", label: "Contact" },
    ],
    hero: {
      title: "Club Al Buraq Sportif",
      alternateTitle: "نادي البراق الرياضي",
      slogan: "Forge ton talent, envole-toi vers la gloire",
      alternateSlogan: "اصقل موهبتك، حلّق نحو المجد",
      primaryCta: "Inscris-toi",
      secondaryCta: "Découvrir le club",
      location: "Ain Atiq, Maroc",
      description:
        "Une académie ambitieuse où les jeunes footballeurs grandissent avec discipline, passion et encadrement professionnel.",
    },
    about: {
      title: "À propos du Club",
      text: "Le Club Al Buraq Sportif est une académie de football dédiée au développement des jeunes talents. Basée à Ain Atiq, notre académie accueille les enfants de 5 à 15 ans dans un environnement professionnel et bienveillant. Notre mission est de découvrir, former et accompagner les futurs champions en leur offrant un encadrement sportif de qualité, tout en veillant à leur épanouissement personnel.",
      stats: ["5-15 Ans", "⚽ Football", "📍 Ain Atiq"],
    },
    whyUs: {
      title: "Pourquoi choisir Al Buraq ?",
      description:
        "Un encadrement pensé pour révéler le potentiel de chaque joueur dans un cadre structuré, motivant et moderne.",
      items: [
        {
          iconClass: "fa-solid fa-star",
          title: "Détection des talents",
          description:
            "Découverte des talents dès le plus jeune âge et perfectionnement de leurs compétences.",
        },
        {
          iconClass: "fa-solid fa-trophy",
          title: "Compétitions",
          description:
            "Participation aux championnats locaux et nationaux pour renforcer la compétitivité.",
        },
        {
          iconClass: "fa-solid fa-dumbbell",
          title: "Programme complet",
          description:
            "Programme de remise en forme et développement des compétences techniques.",
        },
        {
          iconClass: "fa-solid fa-shirt",
          title: "Équipement fourni",
          description:
            "Tenue sportive complète fournie à chaque joueur.",
        },
        {
          iconClass: "fa-solid fa-campground",
          title: "Activités & Sorties",
          description:
            "Organisation de sorties récréatives et d'activités parallèles.",
        },
        {
          iconClass: "fa-solid fa-van-shuttle",
          title: "Transport disponible",
          description:
            "Service de transport disponible pour faciliter l'accès à l'académie.",
        },
      ],
    },
    gallery: {
      title: "Notre Galerie",
      description:
        "En attendant les vraies photos du club, découvrez un aperçu visuel élégant de l'ambiance Al Buraq.",
      zoomHint: "Cliquer pour agrandir",
    },
    results: {
      title: "Résultats & Matchs",
      description: "Suivez les derniers résultats et les prochains matchs du Club Al Buraq Sportif.",
      recentTitle: "Derniers Résultats",
      upcomingTitle: "Matchs à Venir",
      recentMatches: [
        { home: "Al Buraq", scoreHome: 3, away: "FC Ain Atiq", scoreAway: 1, logoHome: "/logo.png", logoAway: null },
        { home: "AS Témara", scoreHome: 0, away: "Al Buraq", scoreAway: 2, logoHome: null, logoAway: "/logo.png" },
        { home: "Al Buraq", scoreHome: 1, away: "US Skhirat", scoreAway: 1, logoHome: "/logo.png", logoAway: null },
      ],
      upcomingMatches: [
        { home: "Al Buraq", away: "RC Ain Aouda", date: "10/05", time: "16:00", logoHome: "/logo.png", logoAway: null },
        { home: "JS Harhoura", away: "Al Buraq", date: "17/05", time: "15:00", logoHome: null, logoAway: "/logo.png" },
      ],
    },
    testimonials: {
      title: "Ce que disent les Parents",
      description: "Les familles qui nous font confiance partagent leur expérience.",
      items: [
        {
          name: "Ahmed B.",
          role: "Parent d'un joueur U13",
          text: "Mon fils a énormément progressé depuis qu'il a rejoint Al Buraq. L'encadrement est sérieux et bienveillant. Je recommande vivement cette académie.",
          rating: 5,
        },
        {
          name: "Fatima Z.",
          role: "Maman d'un joueur U9",
          text: "L'académie ne se concentre pas uniquement sur le football, mais aussi sur les valeurs et la discipline. Mon enfant adore y aller chaque semaine.",
          rating: 5,
        },
        {
          name: "Youssef M.",
          role: "Parent d'un joueur U11",
          text: "Le transport facilite beaucoup les choses. L'équipe technique est compétente et les enfants sont bien encadrés. Bravo Al Buraq !",
          rating: 4,
        },
      ],
    },
    videos: {
      title: "Le Club en Action",
      description: "Découvrez nos entraînements, matchs et moments forts en vidéo.",
      items: [
        {
          title: "Entraînement des U13",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        },
        {
          title: "Highlights saison 2025",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        },
      ],
    },
    registration: {
      title: "Demande d'Inscription",
      description:
        "Remplissez ce formulaire pour enregistrer une demande. Après validation, un message WhatsApp prêt à envoyer s'ouvrira automatiquement.",
      childName: "Nom complet de l'enfant",
      birthYear: "Année de naissance",
      guardianName: "Nom du parent/tuteur",
      phone: "Téléphone *",
      email: "Email",
      submit: "Envoyer la demande",
      success:
        "Votre demande a bien été enregistrée. WhatsApp s'ouvre avec votre message pré-rempli.",
      loading: "Envoi en cours...",
    },
    contact: {
      title: "Restons en Contact",
      description:
        "Contactez l'académie facilement et retrouvez-nous à Ain Atiq grâce aux accès directs ci-dessous.",
      cards: [
        {
          iconClass: "fa-solid fa-phone",
          label: "Téléphone",
          value: "0661-213050",
          href: "tel:0661213050",
        },
        {
          iconClass: "fa-solid fa-envelope",
          label: "Email",
          value: "clubalburaq@gmail.com",
          href: "mailto:clubalburaq@gmail.com",
        },
        {
          iconClass: "fa-brands fa-whatsapp",
          label: "WhatsApp",
          value: "+212 661-213050",
          href: "https://wa.me/212661213050",
        },
        {
          iconClass: "fa-solid fa-location-dot",
          label: "Lieu",
          value: "Ain Atiq, Maroc",
          href: "https://maps.app.goo.gl/xymZaaFSQfkDBwJL8",
        },
      ],
    },
    footer: {
      copyright: "© 2026 Club Al Buraq Sportif. Tous droits réservés.",
    },
  },
  ar: {
    code: "ar",
    brand: "AL BURAQ",
    languageSwitch: "FR",
    academyBadge: "أكاديمية كرة قدم للشباب · من 5 إلى 15 سنة",
    nav: [
      { id: "about", label: "عن النادي" },
      { id: "why-us", label: "لماذا نحن" },
      { id: "gallery", label: "المعرض" },
      { id: "results", label: "النتائج" },
      { id: "testimonials", label: "آراء الأولياء" },
      { id: "videos", label: "فيديوهات" },
      { id: "registration", label: "التسجيل" },
      { id: "contact", label: "تواصل" },
    ],
    hero: {
      title: "نادي البراق الرياضي",
      alternateTitle: "Club Al Buraq Sportif",
      slogan: "اصقل موهبتك، حلّق نحو المجد",
      alternateSlogan: "Forge ton talent, envole-toi vers la gloire",
      primaryCta: "سجّل الآن",
      secondaryCta: "اكتشف النادي",
      location: "عين عتيق، المغرب",
      description:
        "أكاديمية طموحة ينمو فيها اللاعبون الصغار بالانضباط والشغف والتأطير الاحترافي.",
    },
    about: {
      title: "عن النادي",
      text: "نادي البراق الرياضي هو أكاديمية لكرة القدم مخصصة لتطوير المواهب الشابة. تقع أكاديميتنا في عين عتيق، وتستقبل الأطفال من 5 إلى 15 سنة في بيئة احترافية ومشجعة. مهمتنا هي اكتشاف وتكوين ومرافقة أبطال المستقبل من خلال تقديم تأطير رياضي عالي الجودة، مع الحرص على تنميتهم الشخصية.",
      stats: ["5-15 سنة", "⚽ كرة القدم", "📍 عين عتيق"],
    },
    whyUs: {
      title: "لماذا تختار البراق ؟",
      description:
        "تأطير متكامل يهدف إلى إبراز إمكانات كل لاعب داخل بيئة منظمة ومحفزة وعصرية.",
      items: [
        {
          iconClass: "fa-solid fa-star",
          title: "اكتشاف المواهب",
          description: "اكتشاف المواهب في سن مبكر وصقلها.",
        },
        {
          iconClass: "fa-solid fa-trophy",
          title: "المنافسات",
          description: "المشاركة في الدوريات المحلية والوطنية لزيادة التنافسية.",
        },
        {
          iconClass: "fa-solid fa-dumbbell",
          title: "برنامج متكامل",
          description: "برنامج لرفع اللياقة البدنية وتنمية المهارات الفنية.",
        },
        {
          iconClass: "fa-solid fa-shirt",
          title: "زي رياضي متكامل",
          description: "توفير زي رياضي متكامل لكل لاعب.",
        },
        {
          iconClass: "fa-solid fa-campground",
          title: "أنشطة وترفيه",
          description: "تنظيم رحلات ترفيهية وأنشطة موازية.",
        },
        {
          iconClass: "fa-solid fa-van-shuttle",
          title: "خدمة النقل",
          description: "خدمة النقل متوفرة لتسهيل الوصول إلى الأكاديمية.",
        },
      ],
    },
    gallery: {
      title: "معرض الصور",
      description:
        "إلى حين إضافة صور النادي الحقيقية، اكتشف عرضًا بصريًا أنيقًا يعكس أجواء البراق.",
      zoomHint: "اضغط للتكبير",
    },
    results: {
      title: "النتائج والمباريات",
      description: "تابعوا آخر النتائج والمباريات القادمة لنادي البراق الرياضي.",
      recentTitle: "آخر النتائج",
      upcomingTitle: "المباريات القادمة",
      recentMatches: [
        { home: "البراق", scoreHome: 3, away: "نادي عين عتيق", scoreAway: 1, logoHome: "/logo.png", logoAway: null },
        { home: "نادي تمارة", scoreHome: 0, away: "البراق", scoreAway: 2, logoHome: null, logoAway: "/logo.png" },
        { home: "البراق", scoreHome: 1, away: "نادي الصخيرات", scoreAway: 1, logoHome: "/logo.png", logoAway: null },
      ],
      upcomingMatches: [
        { home: "البراق", away: "نادي عين عودة", date: "10/05", time: "16:00", logoHome: "/logo.png", logoAway: null },
        { home: "نادي الهرهورة", away: "البراق", date: "17/05", time: "15:00", logoHome: null, logoAway: "/logo.png" },
      ],
    },
    testimonials: {
      title: "آراء أولياء الأمور",
      description: "العائلات التي تثق بنا تشارك تجربتها.",
      items: [
        {
          name: "أحمد ب.",
          role: "والد لاعب أقل من 13 سنة",
          text: "ابني تطور كثيرًا منذ انضمامه للبراق. التأطير جدي ومحفز. أنصح بشدة بهذه الأكاديمية.",
          rating: 5,
        },
        {
          name: "فاطمة ز.",
          role: "أم لاعب أقل من 9 سنوات",
          text: "الأكاديمية لا تركز فقط على كرة القدم، بل أيضًا على القيم والانضباط. طفلي يحب الذهاب كل أسبوع.",
          rating: 5,
        },
        {
          name: "يوسف م.",
          role: "والد لاعب أقل من 11 سنة",
          text: "خدمة النقل تسهل الأمور كثيرًا. الفريق التقني كفء والأطفال في أيدٍ أمينة. برافو البراق!",
          rating: 4,
        },
      ],
    },
    videos: {
      title: "النادي في الميدان",
      description: "اكتشفوا تداريبنا ومبارياتنا وأبرز اللحظات بالفيديو.",
      items: [
        {
          title: "تداريب أقل من 13 سنة",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        },
        {
          title: "أبرز لحظات موسم 2025",
          url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        },
      ],
    },
    registration: {
      title: "طلب التسجيل",
      description:
        "املأ هذا النموذج لتسجيل الطلب. بعد التأكيد، سيتم فتح واتساب تلقائيًا مع رسالة جاهزة للإرسال.",
      childName: "الاسم الكامل للطفل",
      birthYear: "سنة الازدياد",
      guardianName: "اسم الأب أو الولي",
      phone: "الهاتف *",
      email: "البريد الإلكتروني",
      submit: "إرسال الطلب",
      success: "تم حفظ طلبك بنجاح. سيتم فتح واتساب مع رسالة جاهزة.",
      loading: "جارٍ الإرسال...",
    },
    contact: {
      title: "ابقَ على تواصل",
      description:
        "تواصل مع الأكاديمية بسهولة واعثر علينا في عين عتيق عبر الروابط المباشرة أدناه.",
      cards: [
        {
          iconClass: "fa-solid fa-phone",
          label: "الهاتف",
          value: "0661-213050",
          href: "tel:0661213050",
        },
        {
          iconClass: "fa-solid fa-envelope",
          label: "البريد الإلكتروني",
          value: "clubalburaq@gmail.com",
          href: "mailto:clubalburaq@gmail.com",
        },
        {
          iconClass: "fa-brands fa-whatsapp",
          label: "واتساب",
          value: "+212 661-213050",
          href: "https://wa.me/212661213050",
        },
        {
          iconClass: "fa-solid fa-location-dot",
          label: "الموقع",
          value: "عين عتيق، المغرب",
          href: "https://maps.app.goo.gl/xymZaaFSQfkDBwJL8",
        },
      ],
    },
    footer: {
      copyright: "© 2026 نادي البراق الرياضي. جميع الحقوق محفوظة.",
    },
  },
};

export const socialLinks = [
  {
    id: "facebook",
    iconClass: "fa-brands fa-facebook-f",
    href: "https://web.facebook.com/profile.php?id=61562272963254",
    label: { fr: "Facebook", ar: "فيسبوك" },
  },
  {
    id: "instagram",
    iconClass: "fa-brands fa-instagram",
    href: "#",
    label: { fr: "Instagram", ar: "إنستغرام" },
  },
  {
    id: "youtube",
    iconClass: "fa-brands fa-youtube",
    href: "#",
    label: { fr: "YouTube", ar: "يوتيوب" },
  },
  {
    id: "tiktok",
    iconClass: "fa-brands fa-tiktok",
    href: "#",
    label: { fr: "TikTok", ar: "تيك توك" },
  },
  {
    id: "whatsapp",
    iconClass: "fa-brands fa-whatsapp",
    href: "https://wa.me/212661213050",
    label: { fr: "WhatsApp", ar: "واتساب" },
  },
];

export { galleryItems };